import PropTypes from 'prop-types';
import { useState } from 'react';

import { FormModal, Snackbar } from '../../default';
import { CreateAccessCredentialsForm } from '../../forms';

/**
 * @description Renders a modal for creating a key manager.
 * 
 * @author Paulo Victor Borges
 * @param {boolean} open - Determines whether the modal is open or not.
 * @param {function} onClose - Callback function to close the modal.
 * @returns {JSX.Element} - Returns the JSX element representing the CreateAccessCredentialsModal component.
 */
const CreateAccessCredentialsModal = ({ open, onClose }) => {

    const [showSnackbar, setShowSnackbar] = useState(false)
    const [showErrorSnackbar, setShowErrorSnackbar] = useState(false)
    const [errorMessage, setErrorMessage] = useState('')

    const handleSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setShowSnackbar(false)
    }

    const handleErrorSnackbarClose = (_, reason) => {
        if (reason === 'clickaway') {
            return
        }
        setShowErrorSnackbar(false)
    }

    const handleShowErrorToast = (show, message = '') => {
        setErrorMessage(message)
        setShowErrorSnackbar(show)
    }

    return (
        <>
            <FormModal
                title='Cadastrar novo cliente'
                open={open} onClose={onClose}
            >
                <CreateAccessCredentialsForm
                    onClose={onClose}
                    setShowSnackbar={setShowSnackbar}
                    setShowErrorToast={handleShowErrorToast}
                />
            </FormModal>

            <Snackbar
                open={showSnackbar}
                onClose={handleSnackbarClose}
                vertical='bottom'
                horizontal='right'
                severity='success'
                variant='filled'
                message='Nova chave de acesso criada com sucesso!'
                sx={{ mt: 1 }}
            />

            <Snackbar
                open={showErrorSnackbar}
                onClose={handleErrorSnackbarClose}
                vertical='bottom'
                horizontal='right'
                severity='error'
                variant='filled'
                message={errorMessage}
                sx={{ mt: 1 }}
            />
        </>
    )

}

CreateAccessCredentialsModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired
}

export default CreateAccessCredentialsModal